import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring } from 'ldrs'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import {decryptData } from "../../../Auth/cryptage";




function CreatePermission() {
    const [resources, setResources] = useState([]);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState({
        who:'',
        status:false
    });
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    ring.register()

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);

    useEffect(() => {
        document.title = "GecimmoIA - Ajouterrtisan serve un permission";
    }, []);

    const getResources = async () => {
        try {
            setLoading({
                who:"resources",
                status:true
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://api.ai.easysystem.cloud/api/admin/get-resources', {
                headers: {
                    'X-Custom-Token': token
                }
            });
            if(!result.data.resources){
                setResources([]);
            }else{
                setResources(result.data.resources);
                console.log(result.data.resources);
            }
        } catch (err) {
            setLoading({
                who:"resources",
                status:false
            });
            MySwal.fire({
                title: "Error!",
                text: err.message,
                icon: "error"
            });
        } finally {
            setLoading({
                who:"resources",
                status:false
            });        
        }
    };

    useEffect(() => {
        getResources();
    }, []); 
    
    useEffect(() => {
        setOptions(resources.map((resource) => ({
            value: resource.id,
            label: `${resource.name} (${resource.typeR})`
        })));
    }, [resources]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading({
                who:"submit",
                status:true
            });
            const token = decryptData(Cookies.get('access_token'));
            const formData = new FormData(e.target);
            const permissionName = formData.get('permission_name');
            const selectedResources = formData.getAll('resources');
            // console.log()(permissionName);
            // console.log()(selectedResources);
            await axios.post('https://api.ai.easysystem.cloud/api/admin/create-permission', {
                name: permissionName,
                resources: selectedResources
            }, {
                headers: {
                    'X-Custom-Token': token
                }
            });

            MySwal.fire({
                title: "Success!",
                text: "Permission created successfully",
                icon: "success"
            });
            navigate(-1);
        } catch (err) {
            setLoading({
                who:"submit",
                status:false
            });
            MySwal.fire({
                title: "Error!",
                text: err.message,
                icon: "error"
            });
        }finally{
            setLoading({
                who:"submit",
                status:false
            });
        }
    };

    const back = () => {
        navigate(-1);
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center main-container">
            <Col data-aos="fade-up" className="justify-content-center">
                <Row className="justify-content-center w-100 mb-4">
                    <Col xs={12} md={8} lg={6}>
                        <div className="form-container">
                            <h3 className="createRoleTitle text-center mb-5">Créer une Permission</h3>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4 w-100" controlId="permission_name">
                                    <Form.Label>Nom de permission</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="fs-6"
                                        placeholder="Saisi nom de permission"
                                        name="permission_name"
                                        size="lg"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4 w-100 text-center" controlId="resources">
                                    <Form.Label>Les ressources</Form.Label>
                                    {
                                        loading.status && loading.who ==="resources" ?
                                        (
                                            
                                            <Select
                                                name="resources"
                                                options={options}
                                                isMulti
                                                placeholder={<l-ring
                                                    size="30"
                                                    stroke="3"
                                                    bg-opacity="0"
                                                    speed="2" 
                                                    color="black" 
                                                ></l-ring>}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        ):
                                        (
                                            <Select
                                                name="resources"
                                                options={options}
                                                isMulti
                                                placeholder="Choisissez les ressources"
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        )
                                    }
                                </Form.Group>
                                <Button
                                    className="mb-4 w-100 gradient-custom-4"
                                    size="lg"
                                    type="submit"
                                >
                                    {loading.status && loading.who ==="submit" ? (
                                            <l-ring-2
                                                size="25"
                                                stroke="3"
                                                stroke-length="0.25"
                                                bg-opacity="0.1"
                                                speed="0.8"
                                                color="white"
                                            ></l-ring-2>
                                        )  :(
                                            'Créer'
                                        )}
                                </Button>
                                <Button className="backbtn btn-danger mb-4 w-100" onClick={back} size="lg">
                                    <BsArrowLeft className="btnbackIcon" />
                                    Back
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Container>
    );
}

export default CreatePermission;
